import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  Grid,
  // InputAdornment,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import "./CreateProcess.css";
import DoneIcon from "@mui/icons-material/Done";
import { useEffect, useState } from "react";
import store from "../../../../../store";
import { setIsLoading } from "../../../../../features/userSlice";
import { ETLProcessListEndPointLogic } from "../../../../../logic/Admin/ETL Process List/ETLProcessListEndPointLogic";
import { trackPromise } from "react-promise-tracker";
// import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "#fff",
  padding: "20px 24px",
  borderRadius: "4px",
  boxShadow: "0px 0px 16px #50505085",
  zIndex: "999",
  maxHeight: "80vh",
  overflowY: "auto",
  overflowX: "hidden",
};

const modalHeading = {
  fontSize: "20px",
  fontWeight: "500",
  marginBottom: "16px",
};

type CreateProcessProps = {
  openModal: boolean;
  onCloseModal: any;
  oauthTokenHeader: any;
  setReload: any;
};

const CreateProcess = (props: CreateProcessProps) => {
  const { openModal, onCloseModal, oauthTokenHeader, setReload } = props;
  const [processName, setProcessName] = useState("");
  const [processCommand, setProcessCommand] = useState("");
  const [processType, setProcessType] = useState("");
  const [ETLProcess, setETLProcess] = useState([]) as any;
  const [users, setUsers] = useState([]) as any;
  const [selectedUsers, setSelectedUsers] = useState([]) as any;
  const [resourceProcess, setResourceProcess] = useState(false) as any;
  const [systemAdmin, setSystemAdmin] = useState(true) as any;
  const [manualRunners, setManualRunners] = useState(false) as any;
  const [templateName, setTemplateName] = useState("");
  const [workflowType, setWorkflowType] = useState("");
  const [description, setDescription] = useState("");
  const [isLoad, setIsLoad] = useState(false);

  const [processNameError, setProcessNameError] = useState(false);
  const [processCommandError, setProcessCommandError] = useState(false);
  const [processTypeError, setProcessTypeError] = useState(false);
  const [templateNameError, setTemplateNameError] = useState(false);
  const [workflowTypeError, setWorkflowTypeError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [error, setError] = useState<string | null>(null); // State for error messages

  // Handle input changes
  const handleProcessNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setProcessName(event.target.value);
    setProcessNameError(false); // Reset error state when input changes
  };

  const handleProcessCommandChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setProcessCommand(event.target.value);
    setProcessCommandError(false); // Reset error state when input changes
  };

  const createETLProcess = async (data: any) => {
    store.dispatch(setIsLoading(true));

    try {
      await ETLProcessListEndPointLogic.createETLProcess(
        oauthTokenHeader,
        setETLProcess,
        trackPromise,
        data,
        setIsLoad
      );
      if (ETLProcess === "success") {
        setReload(true);

        setReload(true);
      }
    } catch (error) {
      // setSnackbarSeverity("error");
      setError(ETLProcess?.reason);
    }
  };

  useEffect(() => {
    if (ETLProcess !== "success") {
      setError(ETLProcess?.parsedText?.reason);
    } else {
      setReload(true);
      onCloseModal();
      setReload(true);
      setProcessName("");
      setProcessCommand("");
      setError("");
      setProcessNameError(false);
      setProcessCommandError(false);
      setProcessType("");
      setSelectedUsers([]);
      setResourceProcess(false);
      setSystemAdmin(true);
      setManualRunners(false);
      setTemplateName("");
      setWorkflowType("");
      setDescription("");
    }
    // eslint-disable-next-line
  }, [ETLProcess]);

  useEffect(() => {
    ETLProcessListEndPointLogic.getUsers(
      oauthTokenHeader,
      (fetchedUsers: any) => {
        // Remove duplicates based on `first_name` only
        const uniqueUsers = [
          ...new Map(
            fetchedUsers.map((user: any) => [user.first_name, user])
          ).values(),
        ];
        setUsers(uniqueUsers); // Update the state with only unique users
      }
    );

    // eslint-disable-next-line
  }, [ETLProcess]);

  const handleSubmit = async () => {
    let valid = true;

    if (!processName) {
      setProcessNameError(true);
      valid = false;
    }

    if (!processCommand) {
      setProcessCommandError(true);
      valid = false;
    }

    if (!processType) {
      setProcessTypeError(true);
      valid = false;
    }

    if (processType === "Argo Workflow") {
      if (!templateName.trim()) {
        setTemplateNameError(true);
        valid = false;
      }

      if (!workflowType.trim()) {
        setWorkflowTypeError(true);
        valid = false;
      }

      if (!description.trim()) {
        setDescriptionError(true);
        valid = false;
      }
    }

    if (!valid) {
      return;
    }

    const data = {
      name: processName,
      command: processCommand,
      high_resource: resourceProcess,
      process_type: processType,
      // Conditionally add argo_properties if processType is "Argo Workflow"
      ...(processType === "Argo Workflow" && {
        argo_properties: {
          template_name: templateName,
          workflow_type: workflowType,
          description: description,
        },
      }),
      email_notifications: {
        manual_run_summary: manualRunners,
        sysadmin: systemAdmin,
        users: selectedUsers?.map((user: any) => user.id),
      },
    };

    await createETLProcess(data);
  };

  const handleCancel = () => {
    setProcessName("");
    setProcessCommand("");
    setProcessNameError(false);
    setProcessCommandError(false);
    setError(null);
    onCloseModal();
    setProcessType("");
    setSelectedUsers([]);
    setResourceProcess(false);
    setSystemAdmin(true);
    setManualRunners(false);
    setTemplateName("");
    setWorkflowType("");
    setDescription("");
    setIsLoad(false);
  };

  const processTypes = [
    { value: "System", label: "System" },
    { value: "Business", label: "Business" },
    { value: "Argo Workflow", label: "Argo Workflow" },
  ];

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleCancel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          {/* Modal Header */}
          <Typography
            sx={modalHeading}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Create New Process
          </Typography>

          {/* Modal Body */}

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography sx={{ fontSize: "16px" }}>Process Details</Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="processName"
                required
                label="Process Name"
                value={processName}
                placeholder="How this process should be called"
                error={processNameError}
                size="small"
                onChange={handleProcessNameChange}
                fullWidth
                color="secondary"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                id="processCommand"
                required
                label="Process Command"
                value={processCommand}
                placeholder="What run command should be used"
                error={processCommandError}
                size="small"
                onChange={handleProcessCommandChange}
                fullWidth
                color="secondary"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                disablePortal={false}
                id="processType"
                options={processTypes}
                sx={{ width: "100%" }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={processTypeError}
                    required
                    label="Process Type"
                    placeholder="Choose from list"
                    color="secondary"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
                onChange={(_, newValue: any) => {
                  setProcessType(newValue?.value);
                  setProcessTypeError(false);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography>
                High Resource Process{" "}
                <Switch
                  color="secondary"
                  onChange={() => setResourceProcess(!resourceProcess)}
                  value={resourceProcess}
                />{" "}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {error && error.length >= 1 && (
                <Alert severity="error" sx={{ marginBottom: "16px" }}>
                  {error}
                </Alert>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{ fontSize: "12px", fontWeight: "400", color: "#00000099" }}
              >
                All fields are mandatory.
              </Typography>
            </Grid>
            {/* Argo Attributes */}
            {processType === "Argo Workflow" && (
              <>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: "16px" }}>
                    Argo Attributes
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="templateName"
                    required
                    label="Template Name"
                    placeholder="How this template should be called"
                    error={templateNameError}
                    size="small"
                    fullWidth
                    color="secondary"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    onChange={(e) => {
                      setTemplateName(e.target.value);
                      setTemplateNameError(false);
                    }}
                    value={templateName}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="workflowType"
                    required
                    label="Workflow Type"
                    placeholder="What is the template type"
                    error={workflowTypeError}
                    size="small"
                    fullWidth
                    color="secondary"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    onChange={(e) => {
                      setWorkflowType(e.target.value);
                      setWorkflowTypeError(false);
                    }}
                    value={workflowType}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    size="small"
                    color="secondary"
                    label="Description"
                    error={descriptionError}
                    placeholder="Add additional info"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    onChange={(e) => {
                      setDescription(e.target.value);
                      setDescriptionError(false);
                    }}
                    value={description}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "#00000099",
                    }}
                  >
                    All fields are mandatory.
                  </Typography>
                </Grid>
              </>
            )}

            <Grid item xs={12} sx={{ fontSize: "16px" }}>
              <Typography>Notifications</Typography>
            </Grid>
            <Grid item xs={8}>
              <Box display="flex" gap={4} alignItems="center">
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography>Notify System Admin</Typography>
                  <Switch
                    color="secondary"
                    defaultChecked
                    onChange={() => {
                      setSystemAdmin(!systemAdmin);
                    }}
                    value={systemAdmin}
                  />
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography>Notify Manual Runners</Typography>
                  <Switch
                    color="secondary"
                    onChange={() => setManualRunners(!manualRunners)}
                    value={manualRunners}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={4}>
                  <Typography>Notify The Following Users:</Typography>
                </Grid>
                <Grid item xs={8}>
                  <Autocomplete
                    multiple
                    size="small"
                    fullWidth
                    options={users}
                    getOptionLabel={(option) => option.first_name} // No template literal needed
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    } // Correct comparison
                    value={selectedUsers || []} // Fallback to empty array
                    onChange={(_, newValue: any) => {
                      setSelectedUsers(newValue);
                    }}
                    renderTags={(value, getTagProps) =>
                      value.map((option: any, index) => (
                        <>
                          <Chip
                            {...getTagProps({ index })}
                            key={option.id} // Make key unique by combining `id` and `first_name`
                            label={option?.first_name}
                            sx={{
                              backgroundColor: "#7B1FA2",
                              color: "#FFFFFF",
                              height: "27px",
                            }}
                            deleteIcon={
                              <HighlightOffIcon
                                sx={{
                                  color: "rgba(255, 255, 255, 0.8) !important",
                                  fontSize: "16px !important",
                                }}
                              />
                            }
                          />
                        </>
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search by name or choose from the list"
                        label="Desired Users"
                        color="secondary"
                        sx={{ height: 40 }}
                        slotProps={{
                          inputLabel: {
                            shrink: true,
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography
                sx={{ fontSize: "12px", fontWeight: "400", color: "#00000099" }}
              >
                New ETL Processes are created with a default Enabled state.
              </Typography>
            </Grid>
          </Grid>

          {/* Modal footer */}
          <Grid
            container
            alignItems={"center"}
            justifyContent={"flex-end"}
            mt={2}
          >
            <Grid
              item
              xs={12}
              justifyContent={"flex-end"}
              sx={{ display: "flex" }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                data-tracker="370"
                variant="contained"
                color="secondary"
                endIcon={<DoneIcon />}
                sx={{ marginLeft: 1 }}
                onClick={handleSubmit}
                loading={isLoad}
              >
                Add Process
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default CreateProcess;
